<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{color}}-6 d-flex flex-wrap align-items-center justify-content-between">
				<h4 class="card-title mb-0">
					<button type="button" class="btn btn-link text-white p-0 mr-2" routerLink="/users-list" title="Back">
						<i class="material-icons align-middle">arrow_back</i>
					</button>
					{{ title }}
				</h4>
				<div class="d-flex">
					<button type="button" class="btn btn-sm btn-primary mr-2" (click)="openAddBrandDialog()">
						<i class="material-icons align-middle" style="font-size: 18px;">add</i> Add brand
					</button>
					<button type="button" class="btn btn-sm btn-light" (click)="refresh()" [disabled]="loading">
						Refresh
					</button>
				</div>
			</div>

			<div class="card-body text-dark">
				<p class="text-muted small mb-3">
					Every brand we carry. <strong>Needs login</strong> means the brand has no dedicated vendor login yet —
					click <strong>Create login</strong> to set up the salesperson code, app/portal login and brand scope in one step.
				</p>

				<div class="vendor-toolbar mb-3">
					<div class="vendor-stats">
						<span class="stat-chip stat-total">{{ total }} brands</span>
						<span class="stat-chip stat-needs" [class.is-zero]="needsCount === 0">{{ needsCount }} need a login</span>
					</div>
					<div class="vendor-controls">
						<mat-form-field appearance="outline" class="vendor-search">
							<mat-label>Search brand or supplier</mat-label>
							<input matInput [formControl]="search" autocomplete="off" />
							<i matSuffix class="material-icons text-muted">search</i>
						</mat-form-field>
						<mat-form-field appearance="outline" class="vendor-filter">
							<mat-label>Show</mat-label>
							<mat-select [formControl]="filterCtrl">
								<mat-option value="all">All brands</mat-option>
								<mat-option value="needs_login">Needs login</mat-option>
								<mat-option value="has_login">Has login</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<mat-progress-bar mode="indeterminate" *ngIf="loading" color="accent" class="mb-3"></mat-progress-bar>

				<!-- Table view (desktop) -->
				<div class="vendor-table-wrap">
					<table class="table table-hover table-striped table-bordered vendor-table">
						<thead class="thead-dark text-uppercase text-white">
							<tr>
								<th scope="col">Brand</th>
								<th scope="col">Supplier</th>
								<th scope="col">Status</th>
								<th scope="col">Logins</th>
								<th scope="col" class="text-right">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of filteredRows" [class.is-ready]="row.has_login">
								<td class="vendor-name-cell">{{ row.brand_name }}</td>
								<td class="vendor-supplier">{{ row.supplier_name }} · {{ row.supplier_id }}</td>
								<td>
									<span class="status-pill" [ngClass]="row.has_login ? 'pill-ready' : 'pill-needs'">
										<i class="material-icons">{{ row.has_login ? 'check_circle' : 'person_add' }}</i>
										{{ row.has_login ? 'Has login' : 'Needs login' }}
									</span>
								</td>
								<td>
									<div class="vendor-logins" *ngIf="row.logins.length">
										<span class="login-chip" *ngFor="let l of row.logins"
											[class.login-broad]="!l.dedicated"
											[matTooltip]="l.dedicated ? ('Login ' + l.userid) : ('Shared/house scope — ' + l.salesmancode + ' covers ' + l.brand_count + ' brands')">
											<i class="material-icons">{{ l.blocked ? 'block' : 'badge' }}</i>
											{{ l.userid }} <span class="login-code">({{ l.salesmancode }})</span>
											<button type="button" class="chip-action" (click)="toggleLogin(l)" [matTooltip]="l.blocked ? 'Unblock' : 'Block'">
												<i class="material-icons">{{ l.blocked ? 'lock_open' : 'lock' }}</i>
											</button>
											<button type="button" class="chip-action chip-action-danger" *ngIf="l.dedicated"
												(click)="deleteLogin(l)" matTooltip="Delete permanently">
												<i class="material-icons">delete</i>
											</button>
										</span>
									</div>
									<span class="vendor-logins--empty" *ngIf="!row.logins.length">No login yet</span>
								</td>
								<td class="text-right">
									<button type="button" class="btn btn-sm btn-icon-only btn-unlink" *ngIf="!row.has_login"
										(click)="unlinkBrand(row)" matTooltip="Unlink this brand from its vendor" title="Unlink brand">
										<i class="material-icons align-middle">link_off</i>
									</button>
									<button type="button" class="btn btn-sm"
										[ngClass]="row.has_login ? 'btn-outline-secondary' : 'btn-primary'"
										[disabled]="preparingDialog"
										(click)="openCreateDialog(row)">
										<i class="material-icons align-middle">{{ row.has_login ? 'add' : 'vpn_key' }}</i>
										{{ row.has_login ? 'Add another' : 'Create login' }}
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<!-- Card view (mobile) -->
				<div class="vendor-grid">
					<div class="vendor-card" *ngFor="let row of filteredRows" [class.is-ready]="row.has_login">
						<div class="vendor-card-head">
							<div class="vendor-id">
								<span class="vendor-name">{{ row.brand_name }}</span>
								<span class="vendor-supplier">{{ row.supplier_name }} · {{ row.supplier_id }}</span>
							</div>
							<span class="status-pill" [ngClass]="row.has_login ? 'pill-ready' : 'pill-needs'">
								<i class="material-icons">{{ row.has_login ? 'check_circle' : 'person_add' }}</i>
								{{ row.has_login ? 'Has login' : 'Needs login' }}
							</span>
						</div>

						<div class="vendor-logins" *ngIf="row.logins.length">
							<span class="login-chip" *ngFor="let l of row.logins"
								[class.login-broad]="!l.dedicated"
								[matTooltip]="l.dedicated ? ('Login ' + l.userid) : ('Shared/house scope — ' + l.salesmancode + ' covers ' + l.brand_count + ' brands')">
								<i class="material-icons">{{ l.blocked ? 'block' : 'badge' }}</i>
								{{ l.userid }} <span class="login-code">({{ l.salesmancode }})</span>
								<button type="button" class="chip-action" (click)="toggleLogin(l)" [matTooltip]="l.blocked ? 'Unblock' : 'Block'">
									<i class="material-icons">{{ l.blocked ? 'lock_open' : 'lock' }}</i>
								</button>
								<button type="button" class="chip-action chip-action-danger" *ngIf="l.dedicated"
									(click)="deleteLogin(l)" matTooltip="Delete permanently">
									<i class="material-icons">delete</i>
								</button>
							</span>
						</div>
						<div class="vendor-logins vendor-logins--empty" *ngIf="!row.logins.length">
							No login yet
						</div>

						<div class="vendor-card-actions">
							<button type="button" class="btn btn-sm btn-icon-only btn-unlink" *ngIf="!row.has_login"
								(click)="unlinkBrand(row)" matTooltip="Unlink this brand from its vendor" title="Unlink brand">
								<i class="material-icons align-middle">link_off</i>
							</button>
							<button type="button" class="btn btn-sm"
								[ngClass]="row.has_login ? 'btn-outline-secondary' : 'btn-primary'"
								[disabled]="preparingDialog"
								(click)="openCreateDialog(row)">
								<i class="material-icons align-middle">{{ row.has_login ? 'add' : 'vpn_key' }}</i>
								{{ row.has_login ? 'Add another' : 'Create login' }}
							</button>
						</div>
					</div>
				</div>

				<div *ngIf="!loading && !filteredRows.length" class="text-muted text-center py-4">
					No brands match this filter.
				</div>
			</div>
		</div>
	</div>
</div>
